"use client";
import { observer } from "../../../client-store/index.js";
import navigationRailStore from "../../../client-store/navigationRail.store.js";
import styled from "../../../client-utils/styled/index.js";
import Box from "../../../components/atoms/Box/index.js";
export const NavigationRailContentManagerAtomComponent = observer(styled(Box, {
    name: "NavigationRailContentManager",
    slot: "Root",
})(({ theme }) => ({
    marginLeft: `${navigationRailStore.navigationRailWidth}px`,
    transition: theme.transitions.create("margin-left"),
    [theme.breakpoints.down("expanded")]: {
        marginLeft: 0,
    },
    [theme.breakpoints.up("large")]: {
        marginLeft: `${navigationRailStore.pinnedRailWidth}px`,
    },
})));
export default NavigationRailContentManagerAtomComponent;
